<template>

    <course-list-item
            :last-item="true"
            :course="course"
            :demo-button-text="courseDemoButtonLabel(course)"
            @order="order"
            @demo="demo(course)"/>

</template>

<script>
    import CourseListItem from "./CourseListItem";
    import courseApi from "../data/CourseApi";

    export default {
        props: {
            id: {
                type: [Number, String],
            },
        },
        name: "CourseStatic",
        components: {
            CourseListItem
        },
        data() {
            return {
                course: null,
                error: null,
                loading: false,
            }
        },
        metaInfo() {
            return {
                title: this.metaTitle,
                meta: [
                    {vmid: 'description', name: 'description', content: this.metaDescription}
                ]
            }
        },
        mounted() {
            this.loading = true
            courseApi.fetchCourse(this.id)
                .then(response => {
                    this.course = response
                    this.loading = false
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },

        methods: {
            order(course, addititionalPackage) {
                if (course.ordered) {
                    if (addititionalPackage) {
                        this.$router.push('/order/' + course.idcourse + '?addonly')
                    } else {
                        this.$router.push('/course/' + course.slug)
                    }
                } else {
                    if (addititionalPackage) {
                        this.$router.push('/order/' + course.idcourse + '?add')
                    } else {
                        this.$router.push('/order/' + course.idcourse)
                    }
                }
            },
            demo(course) {
                if (course.freeLessonsCount > 0) {
                    this.$router.push('/course/' + course.slug)
                } else {
                    this.$router.push('/order/' + course.idcourse)
                }
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
            courseDemoButtonLabel(course) {
                if (!course.ordered
                    && course.freeLessonsCount > 0
                    && parseInt(course.price) > 0) {
                    return this.$t('try');
                }
                return null;
            },
        }
    }
</script>

<style src="@/assets/hometeacher/css/main.css">
</style>

